import {useEffect} from 'react';

import { Container, Col, Row } from "react-bootstrap";

import NavbarComponent from './NavbarComponent';
import FooterComponent from './FooterComponent';
import LoadingComponent from "./LoadingComponent";
import AuthErrorComponent from '../components/AuthErrorComponent';
import AlertErrorComponent from '../components/AlertErrorComponent';
import AlertSuccessComponent from '../components/AlertSuccessComponent';
import ServerErrorComponent from '../components/ServerErrorComponent';

export default function ContainerComponent({
    heading = "", 
    children= <></>, 
    isLoading = false, 
    isAuthError = false, 
    alertErrorMessage = "", 
    alertSuccessMessage = "",
    isServerError = false
}) {

    useEffect(() => {
        console.log(isLoading);
    });

    return (
        <>
            <Container fluid className="p-0">
                <NavbarComponent />
                    <Container>
                        {isLoading &&
                            <LoadingComponent />
                        }
                        <Row>
                            <Col className="mt-4">
                                <h1>{heading}</h1>
                                {
                                isServerError || isAuthError
                                ?
                                    <>
                                        <>
                                        {isAuthError && <AuthErrorComponent />}
                                        </> 
                                        <>
                                        {isServerError && !isAuthError && <ServerErrorComponent />}
                                        </>
                                    </>
                                :
                                    <>
                                        {(alertErrorMessage || alertSuccessMessage) &&
                                        <div className="mt-4">
                                            {alertErrorMessage &&
                                            <AlertErrorComponent label={alertErrorMessage} />
                                            }
                                            {alertSuccessMessage &&
                                            <AlertSuccessComponent label={alertSuccessMessage} />
                                            }
                                        </div>
                                        }
                                        <div>
                                            {children}
                                        </div>  
                                    </> 
                                }
                            </Col>
                        </Row>
                </Container>
            </Container>
            <FooterComponent />
        </>
    )
}